export default "__VITE_ASSET__ChzOoCVC__"